import { useState } from "react"
import { Plus, Calendar, CheckSquare, UserPlus, Truck, Sparkles } from "lucide-react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { useAIChat } from "@/contexts/AIChatContext"

export function FloatingActionButton() {
  const [isExpanded, setIsExpanded] = useState(false)
  const navigate = useNavigate()
  const { id: eventoId } = useParams()
  const location = useLocation()
  const { openChat } = useAIChat()
  
  // Verifica se está no contexto de um evento
  const isInEventContext = location.pathname.includes('/evento/')

  const actions = [
    {
      icon: Sparkles,
      label: "Assistente IA",
      action: () => openChat(),
      color: "bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600"
    },
    {
      icon: Calendar,
      label: "Novo Evento",
      action: () => navigate("/eventos?new=true"),
      color: "bg-primary hover:bg-primary/90"
    },
    {
      icon: UserPlus,
      label: "Novo Cliente",
      action: () => navigate("/clientes?new=true"),
      color: "bg-secondary hover:bg-secondary/90"
    },
    {
      icon: CheckSquare,
      label: "Nova Tarefa",
      action: () => navigate(isInEventContext && eventoId ? `/evento/${eventoId}/tarefas?aba=todas&new=true` : "/tarefas-hoje?new=true"),
      color: "bg-accent hover:bg-accent/90"
    },
    {
      icon: Truck,
      label: "Novo Fornecedor",
      action: () => navigate(isInEventContext && eventoId ? `/evento/${eventoId}/fornecedores?new=true` : "/fornecedores-geral?new=true"),
      color: "bg-success hover:bg-success/90"
    },
  ]

  const handleActionClick = (action: () => void) => {
    action()
    setIsExpanded(false)
  }

  return (
    <div className="fixed right-6 bottom-6 z-40 flex flex-col items-end gap-3">
      {/* Ações expansíveis */}
      {isExpanded && (
        <div className="flex flex-col items-end gap-2 animate-in fade-in slide-in-from-bottom-4 duration-300">
          {actions.map((action, index) => (
            <div
              key={index}
              className="flex items-center gap-2 animate-fade-in"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <span className="bg-card text-card-foreground px-3 py-1 rounded-md text-sm font-medium shadow-md whitespace-nowrap">
                {action.label}
              </span>
              <Button
                size="icon"
                className={cn(
                  "h-12 w-12 rounded-full shadow-lg transition-all",
                  action.color
                )}
                onClick={() => handleActionClick(action.action)}
              >
                <action.icon className="h-5 w-5" />
              </Button>
            </div>
          ))}
        </div>
      )}

      {/* Botão principal */}
      <Button
        size="icon"
        className={cn(
          "h-14 w-14 rounded-full shadow-lg transition-all",
          "bg-primary hover:bg-primary/90 hover:scale-110",
          isExpanded && "rotate-45"
        )}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Plus className="h-6 w-6" />
      </Button>
    </div>
  )
}
